import * as tslib_1 from "tslib";
import classNames from "classnames";
import React from "react";
import { forwardRefAs, Generic } from "../../base";
import { TableBody } from "./table-body";
import { TableCell } from "./table-cell";
import { TableFoot } from "./table-foot";
import { TableHead } from "./table-head";
import { TableHeading } from "./table-heading";
import { TableRow } from "./table-row";
export var Table = Object.assign(forwardRefAs(function (_a, ref) {
  var bordered = _a.bordered,
      className = _a.className,
      fullwidth = _a.fullwidth,
      hoverable = _a.hoverable,
      narrow = _a.narrow,
      striped = _a.striped,
      rest = tslib_1.__rest(_a, ["bordered", "className", "fullwidth", "hoverable", "narrow", "striped"]);

  return React.createElement(Generic, Object.assign({
    className: classNames("table", {
      "is-bordered": bordered,
      "is-fullwidth": fullwidth,
      "is-hoverable": hoverable,
      "is-narrow": narrow,
      "is-striped": striped
    }, className),
    ref: ref
  }, rest));
}, {
  as: "table"
}), {
  Body: TableBody,
  Cell: TableCell,
  Foot: TableFoot,
  Head: TableHead,
  Heading: TableHeading,
  Row: TableRow
});
Table.displayName = "Table";